<div
  *ngIf="
    ingredientSearchResult$ | async as ingredientSearchResult;
    else waitingOnData
  "
>
  <div class="title-section">
    <p class="title">
      {{ 'i18n.menuProfitPro.addIngredient.products' | translate }}
    </p>
    <app-view-all-launcher
      [viewAllState]="viewAllState"
      (clickEvent)="viewAllProducts()"
    >
    </app-view-all-launcher>
  </div>
  <div class="content" *ngIf="!!searchKey">
    <div
      *ngFor="let result of ingredientSearchResult"
      class="ingredient-search-result click"
      (click)="selectIngredientToAdd(result)"
    >
      <div class="left">
        <ng-container
          *ngIf="!!result?.brand; else loadingBox"
          [ngTemplateOutlet]="brand"
          [ngTemplateOutletContext]="{ result: result }"
        >
        </ng-container>
        <ng-container
          *ngIf="!!result?.name; else loadingBox"
          [ngTemplateOutlet]="productName"
          [ngTemplateOutletContext]="{ result: result }"
        >
        </ng-container>
        <ng-container
          *ngIf="
            !!result?.pricePerPortion || !!result?.salesPackSize;
            else loadingBox
          "
          [ngTemplateOutlet]="measurments"
          [ngTemplateOutletContext]="{ result: result }"
        >
        </ng-container>
      </div>
      <div class="right" [class.mobile]="platform === platformRef.mobile">
        <ng-container
          *ngIf="!!result?.price; else loadingBox"
          [ngTemplateOutlet]="price"
          [ngTemplateOutletContext]="{ result: result }"
        >
        </ng-container>
        <ng-container
          *ngIf="!!result?.pills && result?.pills.length > 0"
          [ngTemplateOutlet]="pills"
          [ngTemplateOutletContext]="{ result: result }"
        >
        </ng-container>
      </div>
    </div>
  </div>
  <ng-container
    *ngIf="
      ((ingredientSearchResult ?? []).length === 0 && !searchTimeoutTracker) ||
      !searchKey
    "
    [ngTemplateOutlet]="noResults"
  ></ng-container>
</div>

<ng-template #noResults>
  <p class="no-result">
    {{ 'i18n.menuProfitPro.addIngredient.noResults' | translate }}
  </p>
</ng-template>

<ng-template #waitingOnData>
  <div>
    <div class="title-section">
      <p class="title">
        {{ 'i18n.menuProfitPro.addIngredient.products' | translate }}
      </p>
      <app-view-all-launcher
        [viewAllState]="viewAllState"
        (clickEvent)="viewAllProducts()"
      >
      </app-view-all-launcher>
    </div>
    <ng-container [ngTemplateOutlet]="noResults"></ng-container>
  </div>
</ng-template>

<ng-template #measurments let-result="result">
  <p class="remove-margin">
    <span [attr.data-cy]="'product-number-' + result?.productNumber + '-text'">
      #{{ result?.product?.productNumber || ' ' }}
    </span>
    <img
      *ngIf="result?.salesPackSize"
      data-cy="product-card-separator-image"
      src="assets/images/separator.png"
      class="separator"
    />
    <span
      [attr.data-cy]="'product-packsize-' + result?.productNumber + '-text'"
      *ngIf="result?.salesPackSize"
    >
      {{ result?.salesPackSize }}
    </span>

    <ng-container
      *appShowSplit="[split_global_product_price_per_portion_card_flag]"
    >
      <img
        *ngIf="result?.pricePerPortion"
        data-cy="product-card-separator-image"
        src="assets/images/separator.png"
        class="separator"
      />
      <span
        *ngIf="result?.pricePerPortion"
        [attr.data-cy]="'product-' + result?.pricePerPortion + '-text'"
      >
        &nbsp;({{ result?.pricePerPortion }})
      </span>
    </ng-container>
  </p>
</ng-template>

<ng-template #brand let-result="result">
  <div>
    {{ result?.brand }}
  </div>
</ng-template>

<ng-template #productName let-result="result">
  <div class="limit" [innerHTML]="result?.name"></div>
</ng-template>

<ng-template #price let-result="result">
  <div>{{ (result?.price | currency) + ' ' + result?.priceUOM }}</div>
</ng-template>

<ng-template #pills let-result="result">
  <app-usf-product-tag-list
    [tagList]="result?.pills"
    [maxTags]="1"
    [product]="result.product"
    [allTagsClickable]="false"
    class="tags"
  ></app-usf-product-tag-list>
  <p *ngIf="result?.pills?.length > 1">
    {{ '+' + (result?.pills?.length - 1) }}
  </p>
</ng-template>

<ng-template #loadingBox>
  <ion-skeleton-text class="" animated></ion-skeleton-text>
</ng-template>
